import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import reducers from "./../reducers/index";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["USER_REDUCER"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const composeEnhancers = compose;
const middlewares = [thunk];

const enhancer = composeEnhancers(applyMiddleware(...middlewares))
export let store = createStore(persistedReducer, enhancer);

let persistor = persistStore(store)

export default { store, persistor };
